module.exports = __webpack_public_path__ + "img/Considerate Career.0a5e698c.svg";